import { render, staticRenderFns } from "./SortMobile.vue?vue&type=template&id=218ce294&scoped=true&"
import script from "./SortMobile.vue?vue&type=script&lang=js&"
export * from "./SortMobile.vue?vue&type=script&lang=js&"
import style0 from "./SortMobile.vue?vue&type=style&index=0&id=218ce294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218ce294",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\swag\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218ce294')) {
      api.createRecord('218ce294', component.options)
    } else {
      api.reload('218ce294', component.options)
    }
    module.hot.accept("./SortMobile.vue?vue&type=template&id=218ce294&scoped=true&", function () {
      api.rerender('218ce294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Swag/components/Filters/SortMobile.vue"
export default component.exports